import {
  GETWALLETTRANSACTIONLISTONPARENT_SUCCESS,
  GETWALLETTRANSACTIONLISTONPARENT_FAILED,
  RESET_GETWALLETTRANSACTIONLISTONPARENT,
  LOADING_GETWALLETTRANSACTIONLISTONPARENT,
  NETWORK_ERROR_GETWALLETTRANSACTIONLISTONPARENT,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  nvalidRequest: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETWALLETTRANSACTIONLISTONPARENT: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case GETWALLETTRANSACTIONLISTONPARENT_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case GETWALLETTRANSACTIONLISTONPARENT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }

    case RESET_GETWALLETTRANSACTIONLISTONPARENT: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
